const config = {
  local: {
    API_URL: 'http://localhost:4000',
    googleMapsApiKey: 'AIzaSyCtiU6wa7igPLQ51al5irzY9ehDQ55YeH4',
    buildNumber: process.env.REACT_APP_BUILD_NUMBER || 'local',
  },
  development: {
    API_URL: 'https://dev.api.ivyapp.com',
    googleMapsApiKey: 'AIzaSyCtiU6wa7igPLQ51al5irzY9ehDQ55YeH4',
    buildNumber: process.env.REACT_APP_BUILD_NUMBER || 'dev',
  },
  production: {
    API_URL: 'https://api.ivyapp.com',
    googleMapsApiKey: 'AIzaSyCtiU6wa7igPLQ51al5irzY9ehDQ55YeH4',
    buildNumber: process.env.REACT_APP_BUILD_NUMBER || '1.0.0',
  },
}

const env = process.env.NODE_ENV || 'local'

// Allow overriding API URL via .env: REACT_APP_API_URL_OVERRIDE
const overrideApiUrl = process.env.REACT_APP_API_URL_OVERRIDE

export const API_URL =
  overrideApiUrl && overrideApiUrl.length > 0
    ? overrideApiUrl
    : config[env as keyof typeof config].API_URL
export const BUILD_NUMBER = config[env as keyof typeof config].buildNumber
export const googleMapsApiKey = config[env as keyof typeof config].googleMapsApiKey
/** Web Google OAuth client ID for admin portal Sign in with Google (GIS). */
export const googleOAuthClientId = process.env.REACT_APP_GOOGLE_OAUTH_CLIENT_ID || ''

// The live-activity socket server shares the API host (mirrors the mobile app,
// which derives socketBaseUrl from the same per-environment API base URL).
// Override independently with REACT_APP_SOCKET_URL_OVERRIDE if they ever diverge.
const overrideSocketUrl = process.env.REACT_APP_SOCKET_URL_OVERRIDE
export const SOCKET_URL =
  overrideSocketUrl && overrideSocketUrl.length > 0 ? overrideSocketUrl : API_URL
